export default __webpack_public_path__ + "static/media/view_net.e5a86428.svg";